import { render, staticRenderFns } from "./UpdatePwd.vue?vue&type=template&id=602d7aee&scoped=true"
import script from "./UpdatePwd.vue?vue&type=script&lang=js"
export * from "./UpdatePwd.vue?vue&type=script&lang=js"
import style0 from "./UpdatePwd.vue?vue&type=style&index=0&id=602d7aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602d7aee",
  null
  
)

export default component.exports